import InfoWindow from './InfoWindow';

export default InfoWindow;
